import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { CloneRoleRequest, CloneRoleResponse, DeleteRoleRequest, DeleteRoleResponse, SaveRoleRequest, SaveRoleResponse, GetRoleRequest, GetRoleResponse, GetRolesRequest, GetRolesResponse } from "../../models/manage/roles.models";
import { RoleRoutes } from "../../constants/roles/roles.constants";
import { ChangeActivationStateRequest, ChangeActivationStateResponse } from "../../models/manage/branches.models";

@autoinject
export class ManageRolesClientService {

    constructor(private requestClient: RequestClientService) { }

    cloneRole(request: CloneRoleRequest): Promise<CloneRoleResponse> {
        return this.requestClient.post<CloneRoleResponse>(RoleRoutes.CloneRole, {}, request);
    }

    deleteRole(request: DeleteRoleRequest): Promise<DeleteRoleResponse> {
        return this.requestClient.delete<DeleteRoleResponse>(RoleRoutes.DeleteRole, {}, request);
    }

    saveRole(request: SaveRoleRequest): Promise<SaveRoleResponse> {
        return this.requestClient.post<SaveRoleResponse>(RoleRoutes.SaveRole, {}, request);
    }

    changeRoleActivationState(request: ChangeActivationStateRequest): Promise<ChangeActivationStateResponse> {
        return this.requestClient.post<ChangeActivationStateResponse>(RoleRoutes.ChangeActivationState, {},  request);
    }

    getRole(request: GetRoleRequest): Promise<GetRoleResponse> {
        return this.requestClient.get<GetRoleResponse>(RoleRoutes.GetRole, request);
    }

    getRoles(request: GetRolesRequest): Promise<GetRolesResponse> {
        return this.requestClient.get<GetRolesResponse>(RoleRoutes.GetRoles, request);
    }
}